// Recently opened on this phone (Spaces shows the last three): kept in this browser only, a convenience.
import { useEffect } from 'react';

export interface Recent { to: string; title: string; sub: string; kind: 'activity' | 'track' }
const KEY = 'dpw.recent';

export function readRecent(): Recent[] {
  try { const v = JSON.parse(localStorage.getItem(KEY) ?? '[]') as unknown; return Array.isArray(v) ? (v as Recent[]).slice(0, 3) : []; } catch { return []; }
}
/** Remember that this page was opened (once its title is known). */
export function useRemember(r: Recent | null) {
  // Keyed on its text, so a new object each render does not write again.
  const key = r ? JSON.stringify(r) : '';
  useEffect(() => {
    if (!key) return;
    const v = JSON.parse(key) as Recent;
    try { localStorage.setItem(KEY, JSON.stringify([v, ...readRecent().filter(x => x.to !== v.to)].slice(0, 3))); } catch { /* private mode: nothing kept */ }
  }, [key]);
}
